@if (groupe) {
  <pui-modal [modalOpen]="true" [closable]="true" (modalOpen)="openChanged.emit($event)">
    <div pui-modal-title>
      <h1>{{ groupe.libelle | translate }}</h1>
    </div>

    @if (formGroup) {
      <form [formGroup]="formGroup" pui-modal-body>
        <ng-container formArrayName="parametres">
          @for (parametre of parametres.controls; track $index; let i = $index) {
            <div class="parametre" [formGroupName]="i">
              @if (groupe.parametres.length > 1) {
                <h3>{{ parametre.get('libelle')?.value | translate }} :</h3>
              }

              <ul formArrayName="choices">
                @for (choice of getChoices(parametre).controls; track $index; let j = $index) {
                  <li [formGroupName]="j" [class.disabled]="choice.get('disabled')?.value">
                    @if (parametre.get('multi')?.value) {
                      <input [id]="'parametre-' + i + '-choix-' + j" type="checkbox" puiCheckbox formControlName="checked" />
                    } @else {
                      <input
                        [id]="'parametre-' + i + '-choix-' + j"
                        type="radio"
                        puiRadio
                        [name]="'parametre-' + i"
                        [value]="choice.get('value')?.value"
                        [formControl]="getValue(parametre)"
                      />
                    }

                    <label [for]="'parametre-' + i + '-choix-' + j">
                      {{ choice.get('libelle')?.value | translate }}
                      @if (choice.get('precisions')?.value | translate; as precisions) {
                        @if (precisions?.length) {
                          <span class="precisions"> ({{ choice.get('precisions')?.value | translate }}) </span>
                        }
                      }
                    </label>
                  </li>
                }
              </ul>
            </div>
          }
        </ng-container>
      </form>
    }
    @if (!validationAutomatique) {
      <div pui-modal-footer>
        <pui-button (click)="submit()">{{ 'modals.parametres.valider' | translate }}</pui-button>
      </div>
    }
  </pui-modal>
}
